export enum Feature {
  AdFree = 'AdFree',
  DeveloperPage = 'DeveloperPage',
  OpenAppAds = 'OpenAppAds',
  ProfileAnalytics = 'ProfileAnalytics',
  HideProfileAnalytics = 'HideProfileAnalytics', // Temporary
  ShowInterstitialAds = 'ShowInterstitialAds',
  AddNonClubMatch = 'AddNonClubMatch',
  DuprBasicCanAddNonClubMatch = 'DuprBasicCanAddNonClubMatch',
  PhoneVerifyRolloutPt1 = 'PhoneVerifyRolloutPt1',
  ClubCapabilities = 'ClubCapabilities',
  Coaching = 'Coaching',
}

export const features = Object.values(Feature)

// These feature will not show by default
export const featuresMarkedAsExperimental: Feature[] = [
  Feature.ShowInterstitialAds,
  Feature.HideProfileAnalytics,
  Feature.DuprBasicCanAddNonClubMatch,
  Feature.ClubCapabilities,
  Feature.Coaching,
] as const

// These are features we people to have by default
// But we may want to disable them for some users
// Or gate them in the future
export const availableToAllUsers = [
  Feature.OpenAppAds,
  Feature.HideProfileAnalytics,
  Feature.ShowInterstitialAds,
  Feature.DuprBasicCanAddNonClubMatch,
]
